(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon-row-outcome-pairs.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-coupon/assets/javascripts/printable-coupon-row-outcome-pairs.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const formatDate = svs.components.poolBetting.utils.formatDate;
const ParticipantsNames = svs.components.lbUi.participants.ParticipantsNames;
const DescriptionSize = svs.components.lbUi.participants.constants.DescriptionSize;
const selectSportEvent = svs.components.sportinfo.matchInfoRedux.selectors.selectSportEvent;
const OutcomePairGroups = svs.components.poolBetting.printableCoupon.OutcomePairGroups;
const productIds = svs.utils.products.productIds;
const updateOutcomePairGroupsWith10plus = function () {
  let outcomePairGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return outcomePairGroups.map(entry => {
    if (Array.isArray(entry)) {
      return updateOutcomePairGroupsWith10plus(entry);
    }
    return entry === '10' ? '10+' : entry;
  });
};
const resolvedOutcomePairs = _ref => {
  let outcomePairGroups = _ref.outcomePairGroups,
    productId = _ref.productId;
  return productId === productIds.MATCHEN ? outcomePairGroups : updateOutcomePairGroupsWith10plus(outcomePairGroups);
};

const PrintableCouponRowOutcomePairs = _ref2 => {
  let drawEvent = _ref2.drawEvent,
    hasPeriods = _ref2.hasPeriods,
    outcomePairGroups = _ref2.outcomePairGroups,
    participants = _ref2.participants,
    productId = _ref2.productId;
  const sportEvent = useSelector(state => selectSportEvent(state, drawEvent.matchId));
  const matchStart = sportEvent.matchStart;
  return React.createElement("div", {
    className: "pb_print_coupon__row pb_print_coupon__row--outcome_pairs",
    key: drawEvent.eventNumber
  }, hasPeriods && React.createElement("div", {
    className: "event__period"
  }, "Period ".concat(drawEvent.eventNumber)), React.createElement("div", {
    className: "event__number"
  }, drawEvent.eventNumber), React.createElement("div", {
    className: "event__participants"
  }, React.createElement(ParticipantsNames, {
    awayParticipant: participants[1],
    homeParticipant: participants[0],
    nameSize: DescriptionSize.Full
  })), React.createElement("div", {
    className: "event__match_start"
  }, formatDate(matchStart, {
    showDayOfWeek: true
  })), React.createElement(OutcomePairGroups, {
    outcomePairGroups: resolvedOutcomePairs({
      outcomePairGroups,
      productId
    })
  }));
};
setGlobal('svs.components.poolBetting.printableCouponRow.PrintableCouponRowOutcomePairs', PrintableCouponRowOutcomePairs);

 })(window);